import { createRouter, createWebHistory } from "vue-router";
import Bio from "@/views/Bio.vue";
import Contact from "@/views/Contact.vue";
import Publications from "@/views/Publications.vue";
import Projects from "@/views/Projects.vue";
import PublicationViewer from "@/views/PublicationViewer.vue";

const routes = [
  { path: "/", name: "Bio", component: Bio },
  { path: "/contact", name: "Contact", component: Contact },
  { path: "/publications", name: "Publications", component: Publications },
  { path: "/projects", name: "Projects", component: Projects },
  {
    path: "/publications/:slug",
    name: "PublicationViewer",
    component: PublicationViewer,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
